import store from "..";
import { changeLoginState, logout } from "../actions/UserActions";
import { LocalStorageService } from "./LocalStorageService"
import { SessionStorageService } from "./SessionStorageService";
import LobbyHelper from "./helpers/LobbyHelper";

export const Auth = {

  isLoggedIn: false,
  token: null,
  userName: null,
  refreshToken: null,

  getLastLoginDate: function () {
    const authData = LocalStorageService.get('authorizationData');
    if (authData && authData.lastLoginDate) {
      return authData.lastLoginDate;
    }
    return;
  },

  getAccessToken: function () {
    const authData = LocalStorageService.get('authorizationData');
    return authData && authData.access_token;
  },

  isAuthenticated: function () {
    const authData = LocalStorageService.get('authorizationData');

    if (authData && authData.access_token) {
      if (!store.getState().user.isLoggedIn) {
        store.dispatch(changeLoginState(true));
      }
      this.isLoggedIn = true;
      this.token = authData.access_token;
      this.userName = authData.username;
      this.refreshToken = authData.refresh_token;

      return true;

    } else {
      if (store.getState().user.isLoggedIn) {
        Auth.invalidateSession();
        // Utils.onLogoutRefresh();
      }
      return false;
    }
  },

  fillAndGetData: function () {

    const authData = LocalStorageService.get("authorizationData");

    if (authData) {
      this.isLoggedIn = true;
      this.token = authData.access_token;
      this.userName = authData.username;
      this.refreshToken = authData.refresh_token;
    } else {
      this.isLoggedIn = false;
      this.token = null;
      this.userName = null;
      this.refreshToken = null;
    }
    return this;

  },

  invalidateSession: function () {
    LocalStorageService.remove("authorizationData");
    LocalStorageService.remove('realityCheckPeriod')
    LocalStorageService.remove('realityCheckUpdateTime')
    LobbyHelper.clearStoredGamesStatusLocally();
    LocalStorageService.remove('depositBonusRequest');
    LocalStorageService.remove('showSpinsAlert');
    SessionStorageService.clear();
  }

}